import styled from "styled-components";
import { Input } from "antd";

export const Container = styled.div`
  width: 100%;
  height: 94vh;
  background: #fcfcfc;
  padding: 25px 75px 50px 75px;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 4px;
    background-color: #fcfcfc;
  }

  ::-webkit-scrollbar-thumb {
    background: #11a7d9;
    -webkit-border-radius: 1ex;
    -webkit-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.75);
  }

  ::-webkit-scrollbar-corner {
    background: #11a7d9;
  }
`;

export const Title = styled.h1`
  color: #11a7d9;
  font-family: "Inter";
  font-size: 30px;
  font-style: normal;
  font-weight: 700;
  line-height: 100%;
  border-bottom: 1px solid #d4d4d4;
  padding-bottom: 15px;
`;

export const Hr = styled.hr`
  border-radius: 30px;
  background: #11a7d9;
  width: 316px;
  height: 2px;
  margin-bottom: 24px;
  margin-top: -19.5px;
`;

export const AssociatedCard = styled.div`
  width: 100%;
  border-radius: 4px;
  border: 1px solid #f4f4f5;
  background: #fff;
  margin-top: 24px;
`;

export const AssociatedHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 8px;
  padding-top: 16px;
  padding-left: 16px;
  padding-right: 16px;
`;

export const AssociatedTitleBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const AssociatedTitle = styled.h2`
  margin: 0;
  color: #0a5f7c;
  font-family: "Open Sans", sans-serif;
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
`;

export const AssociatedSubtitle = styled.span`
  color: #002244;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
`;

export const PrimaryButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 32px;
  padding: 0 16px;
  border-radius: 6px;
  border: 1px solid #11a7d9;
  background: #11a7d9;
  cursor: pointer;
  color: #fff;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 400;

  &:hover {
    background: #0f97c4;
    border-color: #0f97c4;
  }
`;

export const SearchBox = styled.div`
  padding: 16px 0;
  padding-left: 16px;
  background-color: #fcfcfc;
  border-top: 1px solid #e4e4e7;
  border-bottom: 1px solid #e4e4e7;
`;

export const SearchInput = styled(Input)`
  width: 420px;
  max-width: 100%;
  height: 36px;
  border-radius: 6px;
  border: 1px solid #e4e4e7;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;

  &:hover,
  &:focus,
  &.ant-input-affix-wrapper-focused {
    border-color: #11a7d9;
  }
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 44px 20px 18px;
  text-align: center;
`;

export const EmptyIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #e6f4ff;
  margin-bottom: 8px;
`;

export const EmptyTitle = styled.p`
  margin: 0;
  color: #27272a;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
`;

export const EmptyText = styled.p`
  margin: 0;
  max-width: 380px;
  color: rgba(0, 0, 0, 0.65);
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
`;

export const EmptyLink = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  border: none;
  background: transparent;
  cursor: pointer;
  color: #11a7d9;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 400;

  &:hover {
    text-decoration: underline;
  }
`;
